import { Injectable } from '@angular/core';
import { EndUserLicenseAgreementEndpoint } from '../constants/end-user-license-agreement-endpoint';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { Language } from '../../../../../common/constants/language';
import { RequestHeader } from '../../../../constants';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EndUserLicenseAgreementItemFileService {
  constructor(private http: WrapperHttpService) {}

  getEulaItemFile(eulaItemFileId: string): Observable<string> {
    return this.http
      .withLoading()
      .get<string>(`${API_URL}${EndUserLicenseAgreementEndpoint.Base}/${eulaItemFileId}`, { responseType: 'text' });
  }

  getLastEulaItemFile(params: { languageCode: Language }): Observable<string> {
    return this.http
      .withLoading()
      .get<string>(
        `${API_URL}${EndUserLicenseAgreementEndpoint.Base}${
          EndUserLicenseAgreementEndpoint.Last
        }?${getQueryStringFromObject(params)}`,
        {
          responseType: 'text',
          headers: new HttpHeaders({
            [RequestHeader.SkipInterceptor]: '',
          }),
        },
      );
  }
}
